import { render } from "./TopKv.vue?vue&type=template&id=0cae4e74"
const script = {}

const cssModules = {}
import style0 from "./TopKv.vue?vue&type=style&index=0&id=0cae4e74&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__